/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Outcomeformsummarynoreply4Inputs */

const en_outcomeformsummarynoreply4 = /** @type {(inputs: Outcomeformsummarynoreply4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No reply yet (logged ${i?.when})`)
};

const pt_outcomeformsummarynoreply4 = /** @type {(inputs: Outcomeformsummarynoreply4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem resposta ainda (registo de ${i?.when})`)
};

/**
* | output |
* | --- |
* | "No reply yet (logged {when})" |
*
* @param {Outcomeformsummarynoreply4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsummarynoreply4 = /** @type {((inputs: Outcomeformsummarynoreply4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsummarynoreply4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsummarynoreply4(inputs)
	return pt_outcomeformsummarynoreply4(inputs)
});
export { outcomeformsummarynoreply4 as "outcomeFormSummaryNoReply" }